import store from "data/store";
import api from "./api";
import ChatsService from "./chats";

class UserService {
  init = async () => {
    try {
      await Promise.all([this.#getUser(), this.#getWorkSession()]);
    } catch (error) {
      console.log("UserService init error", error);
      throw error;
    }
  };

  endWorkSession = async () => {
    try {
      const { data } = await api.updateWorkSession(store.workSession.id);
      store.setWorkSession(data);
      if (data?.endedAt) ChatsService.dispose();
    } catch (error) {
      console.log("UserService endWorkSession error", error);
      throw error;
    }
  };

  startWorkSession = async () => {
    try {
      const { data } = await api.createWorkSession();
      if (data && !data.endedAt) ChatsService.init();

      store.setWorkSession(data);
    } catch (error) {
      console.log("UserService startWorkSession error", error);
      throw error;
    }
  };

  #getUser = async () => {
    try {
      const { data } = await api.getUser();
      store.setUser(data);
    } catch (error) {
      console.log("UserService #getUser error", error);
      throw error;
    }
  };

  #getWorkSession = async () => {
    try {
      const { data } = await api.getCurrentWorkSession();
      store.setWorkSession(data);

      if (data && !data.endedAt) ChatsService.init();
    } catch (error) {
      console.log("UserService #getWorkSession error", error);
      throw error;
    }
  };
}

export default new UserService();
